import React from 'react'

interface NotesIconProps {
  hasNotes: boolean
  onClick: () => void
  disabled?: boolean
}

/**
 * NotesIcon - Interactive button for adding/editing notes
 *
 * Displays outline icon when empty, filled when notes exist.
 * Tooltip changes based on state.
 */
export const NotesIcon: React.FC<NotesIconProps> = ({
  hasNotes,
  onClick,
  disabled = false,
}) => {
  const tooltipText = hasNotes ? 'Edit note' : 'Add note'

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex items-center justify-center h-5 w-5 hover:bg-gray-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      title={tooltipText}
      data-testid="notes-icon-button"
    >
      <span
        className="text-[0.65rem]"
        data-testid="notes-icon"
        role="img"
        aria-label={tooltipText}
      >
        {hasNotes ? '📝' : '📋'}
      </span>
    </button>
  )
}
